import React, { useEffect } from 'react';
import '../fonts/fonts.css';
import './particles.css';
import './privacy.css';
import Header from './header';
import grainGif from '../images/grain.gif';

function Privacy({ isLoggedIn, onLogout, onLogin }) {
  useEffect(() => {
    // Scroll to top of page
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="grain-background" style={{ backgroundImage: `url(${grainGif})` }}></div>
      <Header isLoggedIn={isLoggedIn} onLogout={onLogout} onLogin={onLogin} />

      <p className="bingy"></p>
      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>
        
        <div className="privacy-section">
          <h2>Data Collection & Usage</h2>
          <p>
            Albumified is powered by the Spotify Web API. By choosing to use this app, you agree to the use of your 
            Spotify account username and data for your top artists and tracks. This data is used solely to generate 
            your personalized album experience and nothing else.
          </p>
        </div>

        <div className="privacy-section">
          <h2>Data Storage & Privacy</h2>
          <p>
            None of the data used by Albumified is stored or collected anywhere, and it is NOT shared with any third 
            parties. All information is processed in real-time for displaying your personalized album information only. 
            Your Spotify data remains private and secure at all times.
          </p>
        </div>

        <div className="privacy-section">
          <h2>Data Security</h2>
          <p>
            Although you can rest assured that your data is not being stored or used maliciously, if you would like 
            to revoke Albumified's permissions, you can visit your Spotify apps page at 
            <a href="https://www.spotify.com/account/apps/" target="_blank" rel="noopener noreferrer"> 
              www.spotify.com/account/apps/
            </a>
            {' '}and click "REMOVE ACCESS" on Albumified.
          </p>
        </div>

        <div className="privacy-section">
          <h2>Third-Party Integration</h2>
          <p>
            Albumified relies solely on the Spotify API for all data processing. We do not integrate with any other 
            third-party services. Your data is only shared with Spotify in accordance with their privacy and terms of service.
          </p>
        </div>

        <div className="privacy-section">
          <h2>Questions?</h2>
          <p>
            If you have any questions or concerns about this privacy policy or how your data is being used, 
            please feel free to reach out. Your privacy and trust are important to us.
          </p>
        </div>
      </div>
    </>
  );
}

export default Privacy;

